export const theme = {
  colors: {
    primary: '#0D47A1',
    secondary: '#1976D2',
    tertiary: '#42A5F5',
    white: '#FFFFFF',
    text: '#333333',
    error: '#f44336',
  },
  gradient: 'linear-gradient(135deg, #0D47A1 0%, #1976D2 50%, #42A5F5 100%)',
};